module.exports = __webpack_public_path__ + "static/media/disabledCriticalIcon.aeff06ee.svg";